import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideRouter, Router } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { ClerkService } from 'ngx-clerk-iliad';
import { PLATFORM_ID, NgZone } from '@angular/core';
import { H } from 'highlight.run';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { profileCompletionInterceptor } from './app/interceptors/profile-completion.interceptor';

// Initialize console logging toggle based on environment.enableConsoleLogging
(function () {
  try {
    const enabled = (environment as any).enableConsoleLogging !== false;
    if (!enabled) {
      const noop = () => {};
      const c = console as any;
      c.log = noop;
      c.info = noop;
      c.debug = noop;
      c.warn = noop;
      c.table = noop;
      c.trace = noop;
    }
  } catch {}
})();

// High-visibility startup log to verify build and environment in production
try {
  const timestamp = Math.floor(Date.now() / 1000);
  const appVersion = '1';
  const buildNumber = environment.buildNumber || 'dev';
  const fullVersion = `${appVersion}.${buildNumber}`;

  (window as any).__CCN_BUILD__ = environment.buildNumber;

  // Initialize Highlight.io
  if (environment.production) {
    H.init((environment as any).highlightProjectId, {
      environment: 'production',
      version: fullVersion,
      backendUrl: (environment as any).highlightEndpoint,
      otlpEndpoint: (environment as any).highlightOtlpEndpoint,
      disableSessionRecording: true,
      reportConsoleErrors: true,
      networkRecording: {
        enabled: true,
        recordHeadersAndBody: true,
        urlBlocklist: [
          'https://clerk.thefieldlist.com',
          'https://ok-viper-2.clerk.accounts.dev'
        ]
      }
    });

    H.track('App Started', {
      version: fullVersion,
      buildNumber: environment.buildNumber,
      production: environment.production
    });
  }

} catch (e) {
  console.error('Startup/Highlight error:', e);
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, profileCompletionInterceptor]), withFetch()),
    provideRouter(routes),
    provideIonicAngular(),
    {
      provide: ClerkService,
      useFactory: (platformId: Object, router: Router, ngZone: NgZone) =>
        new ClerkService(platformId, router, ngZone),
      deps: [PLATFORM_ID, Router, NgZone]
    }
  ]
}).catch(err => console.error(err));
